import {
  Button,
  Dialog,
  DialogContent,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { tokens } from "../../../../../../../theme";

interface Props {
  open: boolean;
  onClose: () => void;
  onSend: () => void;
}

export default function SendProposalModal({ open, onClose, onSend }: Props) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <DialogContent sx={{ p: 3 }}>
        <Typography fontWeight={700} fontSize={20} sx={{ mb: 1 }}>
          Send Proposal to client
        </Typography>
        <Typography fontSize={14} color="text.secondary" sx={{ mb: 2.5 }}>
          This will send the proposal PDF to the client via Email and change its
          status to Sent.
        </Typography>

        <Stack direction="row" justifyContent="flex-end" spacing={1.5}>
          <Button
            onClick={onClose}
            sx={{
              textTransform: "none",
              color: "text.secondary",
              fontWeight: 500,
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onSend}
            sx={{
              bgcolor: colors.primary[400],
              textTransform: "none",
              borderRadius: 2,
              fontWeight: 600,
              "&:hover": { bgcolor: colors.primary[500] },
            }}
          >
            Send now
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
